module.exports = __webpack_public_path__ + "img/b02.0cd33db2.png";